import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";
import { datasetFilterSchema, dspDatasetsPaginationSchema, dspSharedMetricFields } from "./common";

const dspAudienceMetricFields = {
  ...dspSharedMetricFields,
  new_to_brand_detail_page_views_rate: z.number().nullable(),
  new_to_brand_detail_page_views_rate_prev: z.number().nullable().optional(),
  new_to_brand_detail_page_views_rate_delta: z.number().nullable().optional(),
  new_to_brand_detail_page_views_rate_percent: z.number().nullable().optional(),

  brand_searches_rate: z.number().nullable(),
  brand_searches_rate_prev: z.number().nullable().optional(),
  brand_searches_rate_delta: z.number().nullable().optional(),
  brand_searches_rate_percent: z.number().nullable().optional(),
};

const dspAudienceRowSchema = z.object({
  segment_id: z.union([z.string(), z.number()]).optional(),
  audience_id: z.union([z.string(), z.number()]).optional(),
  segment_name: z.string().optional(),
  segment_source: z.string().optional(),
  segment_class_code: z.string().optional(),
  targeting_method: z.string().optional(),
  start_date: z.string().optional(),
  ...dspAudienceMetricFields,
});

export type DSPAudienceRow = z.infer<typeof dspAudienceRowSchema>;

const dspAudienceQueryRequestSchema = z.object({
  model: z.literal("dspaudience"),
  dimensions: z.union([z.string(), z.array(z.string())]),
  filters: z.array(datasetFilterSchema).optional().default([]),
  sort: z.string().optional(),
  page: z.number().optional(),
  limit: z.number().optional(),
  include_count: z.boolean().optional(),
});

const dspAudienceQueryResponseSchema = z.object({
  data: z.array(dspAudienceRowSchema),
  pagination: dspDatasetsPaginationSchema,
});

export const dspAudienceDatasetsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    method: "post",
    path: "/datasets/query/?audience",
    alias: "dspAudienceDatasetsQuery",
    description: "Query audience datasets by dimensions + filters",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: dspAudienceQueryRequestSchema,
      },
    ],
    response: dspAudienceQueryResponseSchema,
  }).build(),
);
